import { ModalProps } from '@anm/components/modals/Modal';
import TemplateMetaEditModal, { FormValues } from '@anm/components/templates/TemplateMetaEditModal';
import { useCallback, useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { templateActions, templateSelectors } from '../../../store/modules/template';
import { getTemplateId } from '../TemplateVideoWithControls';

import Notifications from './Notifications';

const TemplateEditModal: FC<ModalProps> = props => {
  const dispatch = useDispatch();
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);
  const isUpdateMetaPending = useSelector(templateSelectors.selectUpdateTemplateMetaPending);

  useEffect(
    () => () => {
      dispatch(templateActions.cleanUpdateTemplate());
    },
    []
  );

  const templateId = getTemplateId(currentTemplate?.templateId);

  const onSubmit = useCallback((values: FormValues) => {
    if (!templateId) return;

    dispatch(
      templateActions.updateTemplate({
        ...values,
        templateId,
        tags: values.tags.split(',')
      })
    );
  }, []);

  if (!currentTemplate) return null;

  const { displayName, slug, description, tags } = currentTemplate;

  const initialValues = {
    slug,
    displayName,
    description,
    tags: tags.join(',')
  };

  return (
    <>
      <Notifications />
      <TemplateMetaEditModal isPendingSubmit={isUpdateMetaPending} {...{ onSubmit, initialValues, ...props }} />
    </>
  );
};

export default TemplateEditModal;
